import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../app/store'
import { type Notification } from './GlobalSnackbarNotifier'

export interface UiWidgetsState {
  notification: Notification
}

const initialState: UiWidgetsState = {
  notification: { open: false, severity: 'success', message: 'Message...' }
}

export const uiWidgetsSlice = createSlice({
  name: 'uiWidgets',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<Notification>) => {
      state.notification = action.payload
    }
  }
})

export const {
  setNotification
} = uiWidgetsSlice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectNotification = (state: RootState): Notification => state.uiWidgets.notification

export default uiWidgetsSlice.reducer
